/* HTMLテキストをレンダリングして表示する */
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

interface Props {
  html: string;
}

const HtmlParser: React.FC<Props> = ({ html }) => {
  return <div className="html-parser">{ReactHtmlParser(html)}</div>;
};

export default HtmlParser;
